var map = {
	"./json_business.json": 890,
	"./json_entertainment.json": 532,
	"./json_general.json": 20,
	"./json_health.json": 5,
	"./json_science.json": 442,
	"./json_sports.json": 60,
	"./json_technology.json": 783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 577;